module.exports = __webpack_public_path__ + "static/amy-mtn-0e7d9b61177faab3aa700f8a2758cef7.gif";